module.exports = __webpack_public_path__ + "static/media/movement.8c76bd41.svg";